import * as htmlToImage from 'html-to-image';
import jsPDF from 'jspdf';

class PDFHelper {
	constructor() {
		this.pdf = new jsPDF('p', 'mm', 'a4');
		this.a4Width = 210;
		this.a4Height = 297;
		this.margin = 10;
		this.availableWidth = this.a4Width - 2 * this.margin;
		this.availableHeight = this.a4Height - 2 * this.margin;
	}

	captureElement(elementId) {
		return new Promise((resolve, reject) => {
			const element = document.getElementById(elementId);
			if (!element) {
				reject(new Error(`Element with id ${elementId} not found`));
				return;
			}

			htmlToImage
				.toPng(element, {
					quality: 0.5,
					style: {
						margin: '0',
						padding: '0',
					},
				})
				.then((dataUrl) => resolve(dataUrl))
				.catch(reject);
		});
	}

	addImageToPDF(dataUrl, marginY = 0) {
		return new Promise((resolve) => {
			const img = new Image();
			img.src = dataUrl;
			img.onload = () => {
				const contentWidth = img.width;
				const contentHeight = img.height;

				const effectiveWidth = contentWidth - 2 * this.margin;
				const scale = Math.min(
					this.availableWidth / effectiveWidth,
					this.availableHeight / contentHeight
				);
				const imgWidth = effectiveWidth * scale;
				const imgHeight = contentHeight * scale;

				const xOffset =
					this.margin + (this.availableWidth - imgWidth) / 2;

				this.pdf.addImage(
					dataUrl,
					'PNG',
					xOffset,
					this.margin + marginY,
					imgWidth,
					imgHeight
				);
				resolve({ width: imgWidth, height: imgHeight });
			};
		});
	}

	addPage() {
		this.pdf.addPage();
	}

	save(filename) {
		this.pdf.save(filename);
	}
}

export default PDFHelper;
